import React from "react";
import Layout from "../components/layout";
import { apps } from "../apps";
import { useMetadata } from "../seo";
export default function QuantingoApps() {
  useMetadata(
    "Application support | Quantingo",
    "/quantingoapps",
    "Find Quantingo Android applications on Google Play and get application support.",
  );
  return (
    <Layout>
      <div className="container support-page">
        <p className="eyebrow">Products & support</p>
        <h1>Quantingo applications</h1>
        <p>
          Looking for an app? Find it on Google Play below. If you followed an
          Android app link, install the corresponding app and open the link
          again.
        </p>
        <ul className="app-list">
          {apps.map(([path, name, id]) => (
            <li key={path}>
              <strong>{name}</strong>
              <a
                href={`https://play.google.com/store/apps/details?id=${id}`}
                aria-label={`Find ${name} on Google Play`}
              >
                Google Play ↗
              </a>
            </li>
          ))}
        </ul>
        <p>
          For application support, contact{" "}
          <a href="mailto:contact@quantingo.com">contact@quantingo.com</a>.
        </p>
      </div>
    </Layout>
  );
}
